<template>
  <div>
    <b-modal :ref="id" :id="id" :title="title" scrollable size="lg" title-class="font-18" v-model="show" @show="resetModal">
      <div v-if="pagination && pagination.docs">
        <slot name="header"></slot>
        <input class="form-control mt-3 mb-3" v-model="nameFilter" :placeholder="$t('common.search')" />
        <b-card
          v-for="option in pagination.docs"
          :key="option._id"
          @click="select(option)"
          header-class="bg-transparent border-primary"
          class="border border-primary m-1 mr-4"
          style="cursor: pointer"
          :class="{
            'bg-primary': isSelected(option),
            'text-white': isSelected(option),
          }"
        >
          <slot name="item" :option="option">
            {{ option.name | translate }}
          </slot>
        </b-card>

        <content-loading v-if="isLoading" />
        <!-- Begin: Pagination -->

        <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
          <h5 class="text-center" id="myText">
            {{ $t("data.no-data") }}
          </h5>
        </empty>

        <div v-if="pagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button @click="show = false" variant="secondary" class="btn-label float-right btn-sm">
            <i class="bx bx-window-close label-icon"></i>
            {{ $t("common.close") }}
          </b-button>

          <b-button v-if="multiple" class="btn-label float-right btn-sm mr-1" variant="primary" @click="ok">
            <i class="bx bx-check-double font-size-16 align-middle label-icon"></i>
            {{ $t("common.select") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["id", "title", "store", "multiple", "requestQuery"],
  data() {
    return {
      show: false,
      nameFilter: undefined,
      selections: [],
      request: {
        options: { limit: 15, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    pagination() {
      return this.$store.getters[`${this.store}/paginationForSearch`];
    },
    isLoading() {
      return this.$store.getters[`${this.store}/isLoading`];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.resetModal());
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
    requestQuery: {
      immediate: true,
      deep: true,
      handler(v) {
        if (v) {
          this.request.query = {
            ...this.request.query,
            ...this.requestQuery,
          };
        }
      },
    },
  },
  methods: {
    resetModal() {
      this.$store.dispatch(`${this.store}/paginateForSearch`, this.request);
    },
    select(option) {
      if (!this.multiple) {
        this.show = false;
        this.$emit("selected", option);
        return;
      }

      const founded = this.selections.find((i) => i._id == option._id);
      if (founded) {
        this.selections = [...this.selections.filter((i) => i._id != option._id)];
      } else {
        this.selections.push(option);
      }
    },

    isSelected(option) {
      return !!this.selections.find((i) => i._id == option._id);
    },
    ok() {
      this.show = false;
      this.$emit("selected", this.selections);
    },
  },
};
</script>

<style></style>
